import { FC, PropsWithChildren, ReactNode, useLayoutEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface InfoBlockProps {
  title?: string | ReactNode;
  isCenter?: boolean;
  getHeight?: (height: number) => void;
}

export const InfoBlock: FC<PropsWithChildren<InfoBlockProps>> = ({
  title,
  children,
  isCenter,
  getHeight,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (getHeight && ref.current) {
      getHeight(ref.current.clientHeight);
    }
  }, [getHeight, ref.current]);

  return (
    <div className={styles.infoBlock} ref={ref}>
      {title && (
        <div
          className={classNames(styles.infoBlockTitle, { [styles.infoBlockTitleCenter]: isCenter })}
        >
          {title}
        </div>
      )}

      <div className={styles.infoBlockContent}>{children}</div>
    </div>
  );
};
